import ChallengeTypeMultipleChoice from './ChallengeTypeMultipleChoice';

export default ChallengeTypeMultipleChoice;
